import { render, staticRenderFns } from "./Mentorias.vue?vue&type=template&id=8bea44b2&"
import script from "./Mentorias.vue?vue&type=script&lang=js&"
export * from "./Mentorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports